import {
  Form,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { FormField } from "@/components/ui/form/FormField";
import { Input } from "@/components/ui/input";
import type { UseFormReturn } from "react-hook-form";
import type { PasswordChangeSchemaType } from "@/schemas/passwordChange.schema";
import { AlertMessage } from "@/components/ui/AlertMessage";
import { Button } from "@/components/ui/button";
import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { t } from "i18next";

interface Props {
  onSubmit: (data: PasswordChangeSchemaType) => void;
  form: UseFormReturn<PasswordChangeSchemaType>;
  isSubmitting: boolean;
}

export const PasswordChangeForm = (props: Props): JSX.Element => {
  return (
    <Form {...props.form}>
      <form
        className="w-full flex flex-col"
        onSubmit={props.form.handleSubmit(props.onSubmit)}
      >
        <div className="space-y-4">
          <div className="flex flex-col gap-4">
            <FormField
              control={props.form.control}
              name="oldPassword"
              render={({ field }) => (
                <FormItem className="w-full">
                  <FormLabel>
                    {t("settings.account.changePasswordForm.oldPasswordLabel")}
                  </FormLabel>
                  <FormControl>
                    <Input type="password" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={props.form.control}
              name="newPassword"
              render={({ field }) => (
                <FormItem className="w-full">
                  <FormLabel>
                    {t("settings.account.changePasswordForm.newPasswordLabel")}
                  </FormLabel>
                  <FormControl>
                    <Input type="password" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <div className="flex">
            <FormField
              control={props.form.control}
              name="confirmNewPassword"
              render={({ field }) => (
                <FormItem className="w-full">
                  <FormLabel>
                    {t(
                      "settings.account.changePasswordForm.confirmNewPasswordLabel"
                    )}
                  </FormLabel>
                  <FormControl>
                    <Input type="password" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          {props.form.formState.errors.root?.message && (
            <AlertMessage
              description={props.form.formState.errors.root.message}
              title="Error"
              variant="destructive"
            />
          )}
          <div className="flex justify-end">
            <Button disabled={props.isSubmitting} type="submit">
              {props.isSubmitting && <LoadingSpinner />}
              {t("settings.account.changePasswordForm.submitButton")}
            </Button>
          </div>
        </div>
      </form>
    </Form>
  );
};
